import { render, staticRenderFns } from "./mainDiaobodan.vue?vue&type=template&id=22cc502c&scoped=true&"
import script from "./mainDiaobodan.vue?vue&type=script&lang=js&"
export * from "./mainDiaobodan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc502c",
  null
  
)

export default component.exports